module.exports = __webpack_public_path__ + "static/media/bell-hover.a13f3e4d.svg";